import currency from 'currency.js';
import { bundlePrice } from './bundlePrice';

export const bundlesTotalPrice = (bundles, isTakeAway: boolean) =>
  bundles.reduce((acc, bundle) => acc.add(bundlePrice(bundle, isTakeAway)), currency(0)).value;
